class AudioQuestionStrategy {

    constructor(playScreenController, result) {
        this.playScreenController = playScreenController;
        this.result = result;
        this.mediaContainer = null;
        this.questionContainer = null;
        this.audio = null;
        this.arrowUp = null;
        this.arrowDown = null;
        this.progressBar = null;
    }

    draw() {
        this.mediaContainer = $('#mediaContainer');
        this.questionContainer = $('#questionContainer');
        this.mediaContainer.slideDown();
        this.mediaContainer.css('text-align', 'center');

        this.preloader = this.playScreenController.createPreloader(customIcons["QUESTION_MULTIMEDIA_SOUND"]).appendTo(this.mediaContainer);
        this.preload();
    }

    preload() {
        if (!this.result.own_poll) {
            this.questionContainer.css('background-color', '#' + this.playScreenController.currentQuestion.category.color);
            $(".question-color-wrapper").css("background-color", hex2rgba(this.playScreenController.currentQuestion.category.color, 0.75));
        }
        this.questionContainer.css('min-height', 'calc(100% - 185px)');
        const mainContainer = $('#mainContainer');
        mainContainer.css('overflow', 'auto');
        $(".question-color-wrapper").show();
        this._preloadTimeout = setTimeout(this.load.bind(this), this.result.poll_end_resume ? 750 : 1500);
    }

    load() {

        const color = this.result.own_poll ? this.result.own_poll.color : this.playScreenController.currentQuestion.category.color
        const darkColor = this.result.own_poll ? this.result.own_poll.dark_color : this.playScreenController.currentQuestion.category.dark_color;

        this.arrowUp = $('<div>', {
            'class': 'media-arrow text-center',
            'html': '<i id="textUp" class="fa fa-angle-down fa-3x displayImgArrow" aria-hidden="true"></i>',
            'css': {
                'cursor': 'pointer',
                'color': '#' + darkColor,
                'position': 'relative'
            }
        }).prependTo(this.questionContainer);

        this.arrowDown = $('<div>', {
            'class': 'media-arrow text-center',
            'html': '<i id="textUp" class="fa fa-angle-up fa-3x displayImgArrow" aria-hidden="true"></i>',
            'css': {
                'cursor': 'pointer',
                'color': '#' + darkColor,
                'position': 'relative'
            }
        }).prependTo(this.questionContainer);

        this.audio = $('<audio>', {
            'css': {
                'margin': 'auto'
            },
            'autoplay': true
        }).appendTo(this.mediaContainer);

        this.audio.on('canplaythrough error', () => {
            this.preloader.hide();
            this.progressBar.show();
            this.audio.off('canplaythrough');
        });

        // Safety timeout
        this._safetyTimeout = setTimeout(() => {
             this.preloader.hide();
             this.progressBar.show();
        }, 5000);

        this.audio.attr('src', this.playScreenController.currentQuestion.multimedia);

        this.progressBar = $('<div>', {
            'class': 'audio-progress-bar'
        }).prependTo(this.mediaContainer);

        this.progressBar.append($('<div>', {
            'class': 'audio-progress-bar-background',
            'css': {
                'background-color': '#' + darkColor
            },
            'html': '<div>'
        }));

        var progressBarForegroundImage = $('<img>', {
            'src':  '/images/ic_sound.png',
            'class': 'audio-progress-bar-foreground'
        }).appendTo(this.progressBar);

        this.arrowUp.hide();
        this.hideAnswerButtonTexts();

        $(window).on('resize', () => {
            this.progressBar.css('height', this.progressBar.width() * 0.562);
        });

        // Tint progress bar
        var tintColor = '#' + color
        ImageUtils.tintImage(progressBarForegroundImage, tintColor);

        this.progressBar.hide();

        // Start progress bar
        this.audio.on('seeked', () => {
            var currentTime = this.audio[0].currentTime;
            var duration = this.audio[0].duration;
            var percent = (currentTime / duration) * 100;

            $('.audio-progress-bar-background div').css('width', percent + '%');
            if (!this.audio[0].paused)
                $('.audio-progress-bar-background div').stop(true).animate({ 'width': '100%' }, (duration-currentTime)*1000, 'linear');
        });

        this.audio.on('play', () => {
            var currentTime = this.audio[0].currentTime;
            var duration = this.audio[0].duration;
            $('.audio-progress-bar-background div').stop(true).animate({ 'width': '100%' }, (duration-currentTime)*1000, 'linear');
        });

        this.audio.on('pause', () => {
            $('.audio-progress-bar-background div').stop(true);
        });

        this.audio.on('canplaythrough', () => {
            this.preloader.hide();
            this.progressBar.show();
            this.audio.off('canplaythrough');
        });

        $('body').addClass('stop-scrolling');

        // Eventos para los componentes
        if (!this.result.poll_end_resume) {
            this.audio.on('ended', this.startTime.bind(this));
        } else {
            this.startTime();
        }
        this.arrowDown.on('click', this.startTime.bind(this));
        this.arrowUp.on('click', this.showAudio.bind(this));

    }

    startTime() {
        this.audio.off('ended');
        this.arrowDown.off('click');
        this.arrowDown.on('click', this.hideAudio.bind(this));

        this.audio[0].controls = true;
        this.audio[0].currentTime = 0;
        this.audio[0].pause();

        this.hideAudio();
        $(".question-color-wrapper").hide();
        this.showAnswerButtonTexts();

        if (!this.result.own_poll) {
            this.playScreenController.startTimer(this.result);
        } else {
            this.playScreenController.startTimerPoll(this.result);
        }
    }

    hideAudio() {
        if(this.preloader) {
            this.preloader.hide();
        }
        this.audio[0].controls = false;
        this.audio[0].pause();
        this.mediaContainer.hide();
        this.arrowUp.show();
        this.arrowDown.hide();
        this.progressBar.hide();
        $('body').removeClass('stop-scrolling');
    }

    showAudio() {
        this.audio[0].controls = true;
        this.mediaContainer.show();
        this.arrowUp.hide();
        this.arrowDown.show();
        this.progressBar.show();
        $('body').addClass('stop-scrolling');
    }

    hideAnswerButtonTexts() {
        $('.answerBtn').each(function(i, elem) {
            elem = $(elem);
            elem.text(' ');
        });
    }

    showAnswerButtonTexts() {
        $('.answerBtn').each(function(i, elem) {
            elem = $(elem);
            elem.text(elem.attr('data-answer'));
        });
    }

    cancel() {
        clearTimeout(this._preloadTimeout);
        clearTimeout(this._safetyTimeout);
        if (this.audio) {
            this.audio.off('ended canplaythrough');
            this.audio[0].pause();
        }
    }
}